var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"resource-card",class:( _obj = {
     'hide' : _vm.title === '',
     'resource-card-isef' : _vm.$isIsef,
     'resource-card-ajas' : _vm.$isAjas,
     'resource-card-ysc' : _vm.$isYSC,
     'neweng-resources' : _vm.isResources}, _obj[_vm.name] = _vm.name, _obj ),attrs:{"href":null,"target":"_blank"}},[_c('div',{staticClass:"image",class:{
      'cadsoft-fix' : _vm.title === 'Design & Build Your Own Makerspace',
      'image-ysc' : _vm.$isYSC,
      'image-isef' : _vm.$isIsef,
      'image-broadcom' : _vm.$isBroadcomMasters,
      'image-ohio' : _vm.$isOhioScience,
      'image-sts' : _vm.$isSts},style:({ backgroundImage: _vm.imageBackground })}),_vm._v(" "),_c('div',{staticClass:"info",class:{
    'info-ysc' : _vm.$isYSC,
    'info-auditorium': _vm.isYSCAuditorium,
    'info-ajas' : _vm.$isAjas,
    'info-ohio' : _vm.$isOhioScience,
    'info-cnmiiwsf' : _vm.$isCnmiIwsf,
    'info-sts' : _vm.$isSts,
    'memory-height-fix' : _vm.title === 'Post a favorite STS memory, photo or advice',
    'award-ceremony-height' : _vm.title === 'Regeneron STS Awards Ceremony',
    'info-sts-regeneron' : _vm.$isSts,
    'info-height-sts' : _vm.title === 'Top 300 Scholars'
    }},[(!_vm.hideYscWebinarDate)?_c('p',{staticClass:"title",class:{
      'title-ysc' : _vm.$isYSC,
      'title-ajas' : _vm.$isAjas,
      'title-ohio' : _vm.$isOhioScience,
      'title-cnmiiwsf' : _vm.$isCnmiIwsf,
      'title-sts' : _vm.$isSts
      }},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"subtitle",class:{
      'subtitle-ysc' : _vm.$isYSC,
      'subtitle-ajas' : _vm.$isAjas || _vm.$isIsef,
      'subtitle-ohio' : _vm.$isOhioScience,
      'subtitle-cnmiiwsf' : _vm.$isCnmiIwsf,
      'subtitle-sts' : _vm.$isSts,
      'subtitle-ysc-webinar' : _vm.isYscWebinar
      }},[_vm._v("\n      "+_vm._s(_vm.formatSubTitle(_vm.subtitle))+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }